export type BannerLinkType = 'internal' | 'external'

export function bannerLinkType(url: string, currentHost?: string): BannerLinkType {
  if (url.startsWith('/') && !url.startsWith('//')) return 'internal'
  try {
    const host = new URL(url).hostname.replace(/^www\./, '')
    const own = (currentHost ?? '').replace(/^www\./, '')
    return own && host === own ? 'internal' : 'external'
  } catch {
    return 'external'
  }
}

/** Slider id + 1-based position + link type; never the banner title, image or URL. */
export function homepageBannerParams(
  bannerId: number,
  index: number,
  url: string,
  currentHost?: string,
): Record<string, string | number> | null {
  if (!Number.isInteger(bannerId) || bannerId <= 0 || !url) return null
  return {
    banner_id: bannerId,
    banner_position: index + 1,
    link_type: bannerLinkType(url, currentHost),
    source: 'homepage_fresh_projects',
  }
}
